import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin, Facebook, Instagram, Clock } from "lucide-react";
import { COMPANY } from "@/lib/config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-primary text-brand-bg mt-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center h-10 w-10 rounded-full bg-brand-bg text-brand-primary">
              <Leaf className="h-5 w-5" strokeWidth={1.8} />
            </span>
            <div className="font-display text-xl">Syddansk Group</div>
          </div>
          <p className="mt-4 text-sm text-brand-bg/80 leading-relaxed">
            Professionel havepleje og hækklipning i hele Syddanmark. Vi arbejder med præcision, respekt for naturen og fair priser.
          </p>
          <div className="flex gap-3 mt-6">
            <a
              href={COMPANY.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="h-9 w-9 grid place-items-center rounded-full border border-brand-bg/30 hover:bg-brand-bg hover:text-brand-primary transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href={COMPANY.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="h-9 w-9 grid place-items-center rounded-full border border-brand-bg/30 hover:bg-brand-bg hover:text-brand-primary transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand-bg/60 mb-4">Sider</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:underline underline-offset-4" to="/">Forside</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/om-os">Om os</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/haekklipning">Hækklipning</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/havearbejde">Havearbejde</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/priser">Priser</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/galleri">Galleri</Link></li>
            <li><Link className="hover:underline underline-offset-4" to="/kontakt">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand-bg/60 mb-4">Kontakt</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 shrink-0" />
              <a href={`tel:${COMPANY.phone}`} className="hover:underline underline-offset-4" data-testid="footer-phone">
                {COMPANY.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:underline underline-offset-4" data-testid="footer-email">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 shrink-0" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand-bg/60 mb-4">Områder vi dækker</div>
          <p className="text-sm leading-relaxed text-brand-bg/80">{COMPANY.areas}</p>
          <p className="text-xs text-brand-bg/60 mt-6">CVR: {COMPANY.cvr}</p>
        </div>
      </div>

      <div className="border-t border-brand-bg/15">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-brand-bg/60">
          <span>© {new Date().getFullYear()} Syddansk Group. Alle rettigheder forbeholdes.</span>
          <span>Designet med omtanke i Syddanmark.</span>
        </div>
      </div>
    </footer>
  );
}
